<template>
  <v-row>
    <v-col cols="12">
      <v-card flat>
        <v-card-text class="pa-0">
          <table border="0" cellpadding="0" bordercollapse="1" width="100%">
            <tr>
              <td>Club: <strong>{{ (club || {}).name }}</strong></td>
              <td>Currency: <strong>{{ (club || {}).currency }}</strong></td>
            </tr>
            <tr>
              <td colspan="1"></td>
              <td colspan="1">
                Account Type: <strong>{{ account.is_credit ? 'Credit' : 'Debit' }}</strong>
              </td>
            </tr>
            <tr>
              <td colspan="1">Account Manager:
                <strong v-if="account.manager_group">{{ account.manager_group }}</strong>
                <strong v-else-if="account.identity">{{ account.identity.manager_group }}</strong>
              </td>
              <td colspan="1" style="max-width: 300px">
                <template v-if="!account.is_credit">
                  <p class="mb-2">Balance: <strong>{{ formatNumber(account.bankroll) }}</strong></p>
                </template>
                <template v-else>
                  <span>Who do we have credit with? <strong>{{ questionSit.answer }}</strong></span>
                </template>
              </td>
            </tr>
            <tr>
              <td colspan="1">
                Account Identity: <strong v-if="account.identity">{{ account.identity.name }}</strong>
              </td>
              <td colspan="1" style="max-width: 300px" v-if="!account.is_credit">
                <p class="mb-2">Last Cash-in: <strong v-if="account.latest_cashin">{{ formatNumber(account.latest_cashin.total_amount_chm) }} {{ (club || {}).currency }} on
                  <template v-if="account.latest_cashin.payment_method">
                    <a target="_blank" :href="'https://clubmgmt-web.zapto.org/payment_method/' + account.latest_cashin.payment_method._id">{{ account.latest_cashin.payment_method.method }}</a>
                    <span v-if="account.latest_cashin.transfer">
                          from {{ account.latest_cashin.transfer.sender }}
                          to {{ account.latest_cashin.transfer.receiver }} ({{ account.latest_cashin.transfer.receiver_id }})
                          {{ getPrettyDate(account.latest_cashin.created_at) }}
                        </span>
                  </template>
                  <span v-else>Unknown</span>
                </strong>
                  <span v-else>Unknown</span></p>
              </td>
            </tr>
          </table>

          <v-card v-if="account && account.transactions && account.transactions.length">
            <v-card-text>
              <transaction v-for="tx of account.transactions" :transaction="tx" :key="tx._id"></transaction>
            </v-card-text>
          </v-card>

        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import {mapGetters} from "vuex";
import Transaction from "./Transaction";

export default {
  name: "ClubInfo",
  components: {Transaction},
  computed: {
    questionSit() {
      let answer = "";
      if (this.account && this.account.questions) {
        let q = this.account.questions.filter(el => el.question_id === "6158a3785245fd7be3cfb215");
        if (q.length > 0) {
          answer = q[0].answer;
        }
      }

      return {
        question: "What is my response to the host when trying to sit?",
        answer: answer
      }
    },
    agents() {
      if (!this.club || !this.club.agents) return [];
      return this.club.agents;
    },
    ...mapGetters([
      'activeChatAccountName',
    ]),
    ...mapGetters({
      account: 'activeClubmgmAccount',
      club: 'activeClubmgmClub',
    })
  },
  methods: {
    formatNumber(v, _d=2) {
      if (!v) return v;
      return (v).toFixed(_d).replace(/\d(?=(\d{3})+\.)/g, '$&,');
    },

    getTime(ts) {
      var time = ts.toLocaleTimeString();
      var parts = time.split(" ")[0].split(':');
      return parts[0] + ":" + parts[1];
    },

    ruleName(rule) {
      let name = rule.type;
      if (name === "win_gte_bb") {
        return "If win " + rule.gte_bb + " BBs or more";
      } else if (name === "never") {
        return "Never";
      } else if (name === "win_gte_chm") {
        return "If win $" + rule.gte_chm + " or more";
      } else if (name === "re_double_up") {
        return "If Double-up Again";
      } else if (name === "re_triple_up") {
        return "If Triple-up Again";
      } else if (name === "custom") {
        return rule.custom;
      } else if (name === "when_winning") {
        return "When Winning";
      } else if (name === "always") {
        return "Always";
      } else if (name === "double_up") {
        return "If Double-up";
      } else if (name === "triple_up") {
        return "If Triple-up";
      }
      return name;
    },

    getPrettyDate(date) {
      if (!date) {
        return '?';
      }

      // fix for string date not ISO
      if (!date.includes('T')) {
        date = date.replace(' ', 'T');
      }

      let [year, month, day] = date.split("-");
      let [_, rest] = day.split("T");
      day = _;

      let hour = 0;
      let minute = 0;
      let second = 0;
      if (rest) {
        [hour, minute, second] = rest.split(":");
      }

      let now = new Date();
      let then = new Date(Date.UTC(year, month - 1, day, hour, minute, second));

      let diff = now.getTime() - then.getTime();
      let seconds = Math.floor(Math.abs(diff / 1000));

      let minutes = Math.floor(seconds / 60);
      let hours = Math.floor(minutes / 60);
      let days = Math.floor(hours / 24);
      let weeks = Math.floor(days / 7);
      let months = Math.floor(weeks / 4);

      if (months >= 1) {
        return `${months} month(s) ago`;
      } else if (weeks >= 1) {
        return `${weeks} week(s) ago`;
      } else if (days >= 1) {
        if (days === 1) {
          return "yesterday";
        }

        return `${days} day(s) ago`;
      } else if (hours >= 1) {
        return `${hours} hour(s) ago`;
      } else if (minutes >= 1) {
        return `${minutes} minute(s) ago`;
      } else {
        return `${seconds} second(s) ago`;
      }
    },
  }
}
</script>

<style scoped>
  .club-info {
    height: 100% !important;
    min-height: 100px;
    margin: 0;
  }

  .club-info > div {
    padding: 0;
  }
</style>
